import Rodape from "../../components/rodape";
import BusinessOtimize from "../../components/businessOtimize";
import SquadBeneficios from "../../components/squadBeneficios";
import BannerProjects from "../../components/bannerProjects";
import SquadDiferenciais from "../../components/squadDiferenciais";

function EscopoFechado() {
    return (
        <>
            <BannerProjects
                backgroundImage="../assets/cover-escopo-fechado.png"
                bgMobile="../assets/cover-escopo-fechado-mobile.png"
                title="/ESCOPO"
                titleBold="FECHADO"
                iconSrc="../assets/icone-projectiva-behub.png"
                iconAlt="Projectiva BeHub"
                iconText="be."
                iconTextBold="hub"
                descriptionBold=""
                description={
                    <>
                        Modelo ideal para garantir{" "}
                        <span className="font-bold">
                        previsibilidade, controle e resultados de alto impacto{" "}
                        </span>
                        para projetos com requisitos claros e objetivos específicos.
                    </>
                }
                footerText="VERTICAL PROJECTS | Modelos de entrega"
                buttonText="Quero me conectar"
                buttonColor="from-[#4B3BDB] to-[#A002CB]"
                brand="behub"
            />
            <SquadBeneficios
                title={
                    <>
                        <p className="font-inter-light ">
                            Benefícios desse{" "}
                            <span className="bg-gradient-to-r from-[#4B3BDB] via-[#A002CB] to-[#FC0021] bg-clip-text text-transparent relative">
                                {" "}
                                modelo de entrega
                            </span>
                        </p>
                    </>
                }
                cards={[
                    {
                        icon: "../assets/servicos/estrategia_icon.svg",
                        title: "Estratégia de Entrega Efetiva",
                        text: " Atuamos em parceria com ampla colaboração com nossos clientes para criar estratégias de entregas efetivas e ágeis, que gerem excelência em resultados mensuráveis.",
                        glowColor: "#A002CB",
                    },
                    {
                        icon: "../assets/servicos/alocacao_icon.svg",
                        title: "Liderança Eficaz",
                        text: "Proporcionamos direcionamento claro e execução ágil e eficaz, por meio de líderes com grande expertise e foco nos objetivos e desafios do seu negócio.",
                        glowColor: "#A002CB",
                    },
                    {
                        icon: "../assets/servicos/continuidade_icon.svg",
                        title: "Continuidade Garantida",
                        text: "Cumprimos o que foi prometido com qualidade e pontualidade, garantindo a continuidade da solução.",
                        glowColor: "#A002CB",
                    },
                ]}
            />
            <BusinessOtimize
                backgroundImage="../assets/background_mudancas.png"
                bgMobile="../assets/background_mudancas_mobile.png"
                title={
                    <>
                        Somos referência em{" "}
                        <span className="font-inter-bold">
                            entregas efetivas que transformam negócios.
                        </span>
                    </>
                }
                buttonText="Otimize seu negócio"
                buttonLink="#"
            />
            <SquadDiferenciais
                leftColumnContent={{
                    title: (
                        <>
                            <p className="font-inter-light ">
                                Diferenciais desse{" "}
                                <span className="bg-gradient-to-r from-[#4B3BDB] via-[#A002CB] to-[#FC0021] bg-clip-text text-transparent relative">
                                    {" "}
                                    modelo de entrega
                                </span>
                            </p>
                        </>
                    ),
                    subtitle: "Outros modelos de entrega:",
                    items: [
                        { text: "Squad", link: "/squad" },
                        { text: "Smartsourcing", link: "/smartsourcing" },
                    ],
                    buttonText: "Otimize seu negócio",
                    buttonLink: "#",
                }}
                rightColumnItems={[
                    {
                        id: "01",
                        title: "COMPREENSÃO PROFUNDA",
                        description:
                            "Atuamos em completa parceria com a sua equipe, construindo uma jornada única e personalizada para as necessidades e objetivos específicos do seu negócio.",
                    },
                    {
                        id: "02",
                        title: "EFICIÊNCIA PROFISSIONAL",
                        description:
                            "Implementamos soluções que geram eficiência operacional em todos os aspectos do projeto, otimizam recursos e maximizam o Retorno sobre Investimento (ROI).",
                    },
                    {
                        id: "03",
                        title: "PARCERIA DE LONGO PRAZO",
                        description:
                            "Atuamos em parceria completa com nossos clientes, proporcionando suporte contínuo e assistência durante todas as etapas, inclusive, no pós-projeto.",
                    },
                    {
                        id: "04",
                        title: "ABORDAGEM HOLÍSTICA",
                        description:
                            "Entregamos excelência em resultados ao abordar não somente os sintomas, como as causas dos problemas e desafios de cada projeto.",
                    },
                    {
                        id: "05",
                        title: "RESULTADOS COMPROVADOS",
                        description:
                            "Comprovamos a nossa expertise através de nossos clientes, que confiam e atestam a qualidade e o impacto transformador de nossas entregas em negócios de diferentes complexidades e setores.",
                    },
                ]}
            />
            <Rodape />
        </>
    );
}

export default EscopoFechado;
